/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';
import styles from './QuestionIcon.style';

import svg from './question.svg';

type Props = {
  className?: string,
  title?: string,
  // Self passed
};

const useStyles = createUseStyles(styles);

const QuestionIcon = ({ className, title }: Props): React.Node => {
  const classes: Object = useStyles();

  return (
    <BaseIcon
      className={classNames(classes.root, className)}
      svg={svg}
      title={title}
    />
  );
};

export default compose(React.memo)(QuestionIcon);
